import { RegionService } from "../../services/models/region";
const moduleRegion = {
	namespaced: true,
	state: {
		regions: [],
		loading: false,
	},
	getters: {
		getRegions(state) {
			return state.regions;
		},
		getLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		loadRegions(state, regions) {
			state.regions = regions;
		}
	},
	actions: {
		async loadRegions({ commit, state }) {
			state.loading = true;
			let regions = await RegionService.getAll();
			commit("loadRegions", regions);
			state.loading = false;
		}
	}
}

export default moduleRegion;